import { styled, IconButton, Box } from '@mui/material'
import theme from 'lib/theme'

export const AddButtonWrapper = styled(IconButton)(() => ({
  '&:disabled': {
    '& .MuiSvgIcon-root': { fill: theme.palette.action.disabled },
  },
  borderRadius: '50%',
  fill: theme.palette.commonColors.white,
  width: theme.spacing(3),
  height: theme.spacing(3),
  backgroundColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}))

export const AttributeWrapper = styled(Box)(() => ({
  display: 'flex',
  height: theme.spacing(6),
  alignItems: 'center',
  position: 'relative',
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
}))

export const ProductCardWrapper = styled(Box, {
  shouldForwardProp: (props) => props !== 'handleDeleteProduct',
})<{ handleDeleteProduct: boolean }>(({ handleDeleteProduct }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  '&:hover': {
    backgroundColor: handleDeleteProduct
      ? theme.palette.action.selected
      : 'transparent',
    cursor: handleDeleteProduct ? 'pointer' : 'auto',
  },
}))
